module.exports = __webpack_public_path__ + "static/media/importICloud3.b4f28f75.png";